import { useProductsManager } from "@/composables/products-manager";
import { ProductFeature } from "@/models/product.model";
import { computed } from "vue";
import { PRODUCT } from "@/constants/product.constants";

export const useProductFeaturesManager = () => {
  const { product } = useProductsManager();

  const getAppropriateFeature = (
    featureId: number
  ): ProductFeature | undefined => {
    if (product.value) {
      return product.value.features.find((feature: ProductFeature): boolean => {
        return feature.id === featureId;
      });
    }
    return undefined;
  };

  const isAssetManagementFeatureEnabled = computed<boolean>(() => {
    const appropriateFeature = getAppropriateFeature(
      PRODUCT.FEATURES.assetManagementTier2.id
    );
    return !!appropriateFeature && appropriateFeature.isEnabled;
  });
  const isWorkflowManagementFeatureEnabled = computed<boolean>(() => {
    const appropriateFeature = getAppropriateFeature(
      PRODUCT.FEATURES.workflowManagement.id
    );
    return !!appropriateFeature && appropriateFeature.isEnabled;
  });
  const isContentAuthoringTier1FeatureEnabled = computed<boolean>(() => {
    const appropriateFeature = getAppropriateFeature(
      PRODUCT.FEATURES.contentAuthoringTier1.id
    );
    return !!appropriateFeature && appropriateFeature.isEnabled;
  });
  const isContentAuthoringTier2FeatureEnabled = computed<boolean>(() => {
    const appropriateFeature = getAppropriateFeature(
      PRODUCT.FEATURES.contentAuthoringTier2.id
    );
    return !!appropriateFeature && appropriateFeature.isEnabled;
  });

  return {
    getAppropriateFeature,
    isAssetManagementFeatureEnabled,
    isWorkflowManagementFeatureEnabled,
    isContentAuthoringTier1FeatureEnabled,
    isContentAuthoringTier2FeatureEnabled
  };
};
